"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileExpanded = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const TileExpanded = ({ fill = "#E6E6E6", size = 16, title = "Expanded view" }) => (react_1.default.createElement(Base_1.Base, { size: size, smooth: false, fill: fill, title: title },
    react_1.default.createElement("path", { d: "M7,7H1V1h6zM15,1H9v6h6zM7,9H1v6h6zM15,9H9v6h6z" })));
exports.TileExpanded = TileExpanded;
//# sourceMappingURL=TileExpanded.js.map